/**
 * WizardLayout - layout for wizard pages.
 *
 * Chat + input on the left (or full width when no proposal).
 * Proposal panel on the right when a proposal exists.
 * Starts compact and grows as conversation expands, up to parent max-height.
 */

import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'

interface WizardLayoutProps {
  chat: ReactNode
  input: ReactNode
  proposal?: ReactNode
}

export function WizardLayout({ chat, input, proposal }: WizardLayoutProps) {
  return (
    <div className="flex max-h-[inherit]">
      {/* Chat column */}
      <div
        className={cn(
          'flex flex-col max-h-[inherit]',
          proposal ? 'w-[60%] border-r-[0.5px] border-r-[var(--rule)]' : 'w-full'
        )}
      >
        {chat}
        {input}
      </div>

      {/* Proposal column */}
      {proposal && (
        <div className="flex w-[40%] flex-col bg-[var(--bg)]">
          {proposal}
        </div>
      )}
    </div>
  )
}
